import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
const initialState = {
    currentItemIndex: -1,
    searchTerm: '',
};
const useItemWorkflowTableStore = create()(immer((set) => ({
    ...initialState,
    setCurrentItemIndex: (nextValue) => {
        set((state) => ({
            currentItemIndex: typeof nextValue === 'function' ? nextValue(state.currentItemIndex) : nextValue,
        }));
    },
    adjustCurrentItemIndex: ({ insertedItemIndex, removedItemIndex }) => {
        set((state) => {
            if (insertedItemIndex !== undefined) {
                // If the item was inserted after the selected index → no shift
                if (insertedItemIndex > state.currentItemIndex)
                    return;
                return { currentItemIndex: state.currentItemIndex + 1 };
            }
            if (removedItemIndex !== undefined) {
                // If the item was removed after the selected index → no shift
                if (removedItemIndex > state.currentItemIndex)
                    return;
                // If the selected item was removed, then remove selection at all
                if (removedItemIndex === state.currentItemIndex)
                    return { currentItemIndex: -1 };
                return { currentItemIndex: state.currentItemIndex - 1 };
            }
        });
    },
    setSearchTerm: (searchTerm) => {
        set((state) => {
            state.searchTerm = searchTerm;
        });
    },
    resetReceiptItemsTableState: () => set(initialState),
})));
export { useItemWorkflowTableStore };
